/* istanbul ignore file */
import React from 'react';
import LeadsBreadcrumbs from 'domain/sales/lead/shared/LeadsBreadcrumbs';
import { CreateBreadcrumbItem } from 'framework/ui/BreadCrumbs';

/**
 * Returns lead create pages breadcrumbs.
 * @returns {*}
 * @constructor
 */
const CreateLeadBreadcrumbs = () => (
  <LeadsBreadcrumbs>
    <CreateBreadcrumbItem entity="Lead" />
  </LeadsBreadcrumbs>
);

export default CreateLeadBreadcrumbs;
